/** Tokens at the magnitude an operator reads them: 444328 -> "444K",
    1000000 -> "1M", 1400000 -> "1.4M".

    Nobody acts on the exact token count of a context window - the question is
    how full it is - and an exact figure that ticks on every poll reads as
    precision the number does not have. Shared by the legacy chat's context
    meter and the learning agents' context gauge so the two agree. */
export const formatTokens = (n: number): string => {
  if (n >= 1_000_000) {
    const m = n / 1_000_000;
    // One decimal below 10M ("1.4M"), none above it or on a whole million: a
    // tenth of a million is a distinction worth drawing, a tenth of ten is not.
    return `${m >= 10 || Number.isInteger(m) ? Math.round(m) : m.toFixed(1)}M`;
  }
  if (n >= 1_000) return `${Math.round(n / 1_000)}K`;
  return `${n}`;
};
